import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { DataTable } from "../../components/data-table";
import { GETCOMPANIES_REQ, TOGGLECOMPANY_REQ } from "../../actions";
import { TOGGLECOMPANY_RESPONSE } from "../../constants/action_types";

import { ToggleCustomerStatus } from "./components/customer_toggle_action";
import { FlatButton } from "../../components/buttons";
import { ACL } from "../../components/acl";
import { ADMIN, PARTNER, SUPERADMIN, FINANCEADMIN } from "../../constants/roles";

function Customers() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filter = localStorage.getItem("customer_filter");

  const urlParams = useRef({});

  if (filter) {
    urlParams.current["filter.keyword"] = filter;
  }

  const customersList = useSelector((state) => state?.company?.list);
  const customerListUpdated = useSelector(
    (state) => state?.company?.update_response
  );

  useEffect(() => {
    if (customerListUpdated?.type === TOGGLECOMPANY_RESPONSE) handleFetch();
  }, [customerListUpdated]);

  const toggleCompany = (company) => {
    dispatch(
      TOGGLECOMPANY_REQ({
        company_uid: company.company_uid,
        status: company.is_active ? "DEACTIVATE" : "ACTIVATE",
        reason: company.reason,
      })
    );
  };

  const handleFetch = async (params) => {
    console.log(params);
    if (params) {
      urlParams.current.page = params.page;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword || "";
    }
    dispatch(GETCOMPANIES_REQ(urlParams.current));
  };

  const columns = [
    {
      name: "#",
      key: "company_id",
      width: 16,
      disableSort: true,
    },
    {
      name: "Customer Name",
      key: "company_name",
      onCellClick: (payload) => {
        navigate(`/customers/${payload.row.company_uid}/details`);
      },
    },
    { name: "Company Email", key: "company_email", disableSort: true },
    { name: "Country", key: "company_country", disableSort: true },
    { name: "Created at", key: "created_at", type: "date" },
    { name: "Total users", key: "total_users", disableSort: true },
    {
      name: "Stage",
      key: "company_status",
      disableSort: true,
    },
    {
      name: "Status",
      key: "is_active",
      disableSort: true,
      formatText: (isActive) => (isActive ? "Active" : "Inactive"),
      processClassName: (isActive) =>
        isActive ? "text-green-500 font-medium" : "text-red-500 font-medium",
    },
    {
      name: "Actions",
      type: "actions",
      showFor: [SUPERADMIN, ADMIN, FINANCEADMIN],
      actions: [
        {
          element: <ToggleCustomerStatus onConfirm={toggleCompany} />,
        },
      ],
    },
  ];

  return (
    <main class="-mt-24">
      <div class="mx-auto h-full  max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div class="h-full flex flex-1 space-x-4">
          <section
            aria-labelledby="primary-heading"
            class="flex h-full min-w-0 flex-1 flex-col lg:order-last"
          >
            <div class="h-full">
              <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
                <div class="p-2 h-full ">
                  <div class="flow-root h-full">
                    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-full">
                      <div class="h-full inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                        <DataTable
                          name="Customers"
                          enableSort={true}
                          columns={columns}
                          remote={true}
                          preserve={["keyword", "page"]}
                          syncWithUrl={true}
                          data={customersList?.data}
                          totalCount={customersList?.totalCount}
                          handleFetch={handleFetch}
                          toolbar={{
                            search: {
                              enable: true,
                            },
                            customAction: (
                              <ACL showFor={[SUPERADMIN, ADMIN, FINANCEADMIN, PARTNER]}>
                                <FlatButton
                                  onClick={() => navigate("/customers/create")}
                                >
                                  Add Customer
                                </FlatButton>
                              </ACL>
                            ),
                          }}
                          footer={{ paginator: { enable: true, limits: [10] } }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default Customers;
